import { useContext } from 'react';

import ImageGroupDataContext, { ImageGroupDataValues } from './context';

const useImageGroupData = (): ImageGroupDataValues => useContext(ImageGroupDataContext);

export default useImageGroupData;
